<template>
	<div class="r-b-toolsbar-wrap">
		<!-- <a
      href="https://wj.qq.com/s2/4368214/0e1d/"
      target="_blank"
      title="5周年庆典"
      class="questionnaire"
    >
      <span class="questionnaire__img"></span>
    </a> -->
		<ul>
			<li>
				<a href="/myCarts">
					<i id="js-collect-icon" class="collect"></i>
				</a>
			</li>
			<li>
				<a href="#">
					<i class="tutorial"></i>
				</a>
			</li>
			<li>
				<a href="/downloadHistory">
					<i class="download"></i>
				</a>
			</li>
			<li>
				<a href="/personlCenter">
					<i class="money"></i>
				</a>
			</li>
			<li class="customer-service">
				<a>
					<i class="service"></i>
				</a>
				<WechatCode class="wechat-code" />
			</li>
		</ul>
		<button class="to-top" style="display: none;">
			<i></i>
		</button>
		<a target="_blank" title="我要吐槽" class="feedback">
			<span class="feedback__mascot"></span>
			<span class="feedback__text"></span>
		</a>
	</div>
</template>

<script>
import WechatCode from "@/components/WechatCode.vue";
export default {
	components: {
		WechatCode,
	},
};
</script>

<style scoped lang="scss">
.customer-service {
	position: relative;

	&:hover {
		.wechat-code {
			visibility: visible;
		}
	}
}

.wechat-code {
	position: absolute;
	right: 42px;
	top: -52px;
	visibility: hidden;
}
</style>
